// Wrapper para /api/quota/me.

import { apiFetch } from './api';

export interface LicenseInfo {
  id: number;
  slug: string;
  monthly_sessions_one: number;
  monthly_sessions_gr: number;
  default_duration_one_min: number;
  default_duration_gr_min: number;
}

export interface QuotaResponse {
  status: 'ok';
  period: { year: number; month: number };
  license: LicenseInfo | null;
  consumed: { one: number; gr: number };
  remaining: { one: number; gr: number };
  assigned_teacher_id: number | null;
}

export async function getMyQuota(year?: number, month?: number): Promise<QuotaResponse> {
  const q = new URLSearchParams();
  if (year !== undefined) q.set('year', String(year));
  if (month !== undefined) q.set('month', String(month));
  const qs = q.toString();
  return apiFetch<QuotaResponse>(`/quota/me${qs ? `?${qs}` : ''}`);
}
